import React, { useState } from "react";
import { Breadcrum } from "../../components/Layout/breadcrum";
import { CustomTable } from "../../components/Table";
import { createColumnHelper } from "@tanstack/react-table";
import {
  capitalizeFirstLetter,
  convertEpochToDateTime,
} from "../../utils/utility";
import { POST } from "../../utils/webService";
import {
  DOWNLOAD_S3_LABEL,
  FETCH_LABELS_REPORT_LIST,
  GET_SYSTEM_LOG,
} from "../../utils/ApiUrls";
import { toast } from "react-hot-toast";
import { useSelector } from "react-redux";
import AccessDenied from "../../components/AccessDenied";
import { checkPageAuthorized } from "../../redux/reducers/role";
import SortIcon from "../../assets/sort.svg";
import EyeIcon from "../../assets/blueEye.svg";
import CenterModal from "../../components/CustomModal/customCenterModal";
import CrossIcon from "../../assets/CloseIcon.svg";
import PaginationComponent from "../../components/Pagination";

const BulkLabelList = () => {
  const columnsHelper = createColumnHelper<any>();
  const [bulkDownloadLabelList, setBulkDownloadLabelList] = React.useState<any>(
    [],
  );
  const roles = useSelector((state: any) => state?.roles);
  // const isActive = roles.roles?.[0]?.menu?.[8]?.menu?.[0]?.pages?.[3]?.isActive;
  const [totalItemCount, setTotalItemCount] = useState<any>();

  React.useEffect(() => {
    (async () => {
      try {
        const { data: response } = await POST(FETCH_LABELS_REPORT_LIST, {
          limit: 10000,
          pageNo: 1,
        });
        if (response?.success) {
          setBulkDownloadLabelList(response?.data);
          setTotalItemCount(response?.totalLabelCount);
        } else {
          // toast.error(data?.message);
        }
      } catch (error) {
        console.error(error);
      }
    })();
  }, []);

  const downloadFile = async (name: any) => {
    try {
      const { data: response } = await POST(DOWNLOAD_S3_LABEL, {
        labelId: name,
      });
      if (response?.success) {
        toast.success(response?.message);
        window.location.href = response?.url;
      } else {
        // toast.error(data?.message);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const bulkDownloadColumns = [
    columnsHelper.accessor("userId", {
      header: () => {
        return (
          <p className="font-Open text-sm font-semibold leading-[18px] text-[#004EFF]">
            Start Date
          </p>
        );
      },
      cell: (info: any) => {
        const data = info?.row?.original;
        return (
          <div className="flex items-center justify-start font-Open font-semibold text-sm leading-5 text-[#1C1C1C]">
            {convertEpochToDateTime(data?.reqInitiatedAt)}
          </div>
        );
      },
    }),
    columnsHelper.accessor("userName", {
      header: () => {
        return (
          <p className="font-Open text-sm font-semibold leading-[18px] text-[#004EFF]">
            End Date
          </p>
        );
      },
      cell: (info: any) => {
        const data = info?.row?.original;
        return (
          <div className="flex items-center justify-start font-Open font-semibold text-sm leading-5 text-[#1C1C1C]">
            {convertEpochToDateTime(data?.reqCompletedAt)}
          </div>
        );
      },
    }),
    columnsHelper.accessor("eventName", {
      header: () => {
        return (
          <p className="font-Open text-sm font-semibold leading-[18px] text-[#004EFF]">
            Label Link
          </p>
        );
      },
      cell: (info: any) => {
        const data = info?.row?.original;
        return (
          <div className="flex items-center justify-start font-Open font-semibold text-sm leading-5 text-[#1C1C1C]">
            <a
              className={`text-[#004EFF] ${
                data?.status !== "SUCCESS"
                  ? "pointer-events-none opacity-40"
                  : "cursor-pointer"
              }`}
              onClick={() => downloadFile(data?.downloadLink)}
            >
              Download Label
            </a>
          </div>
        );
      },
    }),
    columnsHelper.accessor("logType", {
      header: () => {
        return (
          <p className="font-Open text-sm font-semibold leading-[18px] text-[#004EFF]">
            Filter
          </p>
        );
      },
      cell: (info: any) => {
        const data = info?.row?.original;
        let partnerArr =
          data?.filter?.filterArrOne?.[0]?.["service.partnerName"]?.["$in"];
        return (
          <div className="flex justify-start">
            <div className="w-full max-w-[180px] font-Open text-sm leading-5 text-[#1C1C1C]">
            <p className="font-semibold">Partner Name:</p>
            {partnerArr?.length > 0 ? (
              partnerArr?.map((el: any, i: any) => {
                return (
                  <p
                    key={`${el}-${i}`}
                    className="my-2 w-full break-words font-Open text-xs font-normal"
                  >
                    {el.toString()}
                  </p>
                );
              })
            ) : (
              <p className="mt-1 font-normal">N/A</p>
            )}
            </div>
          </div>
        );
      },
    }),
    columnsHelper.accessor("ipAddress", {
      header: () => {
        return (
          <p className="font-Open text-sm font-semibold leading-[18px] text-[#004EFF]">
            Status
          </p>
        );
      },
      cell: (info: any) => {
        const data = info?.row?.original;
        return (
          <div className="flex items-center justify-start font-Open font-semibold text-sm leading-5 text-[#1C1C1C]">
            {data?.status}
          </div>
        );
      },
    }),
  ];

  const renderCards = () => {
    return (
      <div className="space-y-3">
        {bulkDownloadLabelList?.map((item: any, idx: number) => {
          const partnerArr =
            item?.filter?.filterArrOne?.[0]?.["service.partnerName"]?.["$in"];
          const canDownload = item?.status === "SUCCESS";
          return (
            <div
              key={item?._id || item?.downloadLink || idx}
              className="bg-white rounded-lg shadow-md border border-[#E8E8E8] p-4"
            >
              <div className="flex items-start justify-between gap-4">
                <div className="min-w-0">
                  <p className="font-Open text-xs font-semibold text-[#004EFF]">
                    Status
                  </p>
                  <p className="font-Open text-sm font-semibold text-[#1C1C1C] break-words">
                    {item?.status || "N/A"}
                  </p>
                </div>
                <button
                  type="button"
                  className={
                    "font-Open text-sm font-semibold " +
                    (canDownload
                      ? "text-[#004EFF] cursor-pointer"
                      : "text-[#004EFF] opacity-40 cursor-not-allowed")
                  }
                  onClick={() => canDownload && downloadFile(item?.downloadLink)}
                  disabled={!canDownload}
                >
                  Download Label
                </button>
              </div>

              <div className="mt-3 grid grid-cols-1 gap-3">
                <div className="flex items-start justify-between gap-4">
                  <div className="min-w-0">
                    <p className="font-Open text-xs font-semibold text-[#004EFF]">
                      Start Date
                    </p>
                    <p className="font-Open text-sm text-[#1C1C1C] break-words">
                      {convertEpochToDateTime(item?.reqInitiatedAt)}
                    </p>
                  </div>
                  <div className="min-w-0 text-right">
                    <p className="font-Open text-xs font-semibold text-[#004EFF]">
                      End Date
                    </p>
                    <p className="font-Open text-sm text-[#1C1C1C] break-words">
                      {convertEpochToDateTime(item?.reqCompletedAt)}
                    </p>
                  </div>
                </div>

                <div>
                  <p className="font-Open text-xs font-semibold text-[#004EFF]">
                    Filter
                  </p>
                  <div className="mt-1">
                    <p className="font-Open text-sm font-semibold text-[#1C1C1C]">
                      Partner Name:
                    </p>
                    {partnerArr?.length > 0 ? (
                      <div className="mt-1 space-y-1">
                        {partnerArr?.map((el: any, i: number) => (
                          <p
                            key={`${el}-${i}`}
                            className="font-Open text-xs font-normal text-[#1C1C1C] break-words"
                          >
                            {el?.toString?.() || String(el)}
                          </p>
                        ))}
                      </div>
                    ) : (
                      <p className="font-Open text-xs font-normal text-[#1C1C1C]">
                        N/A
                      </p>
                    )}
                  </div>
                </div>
              </div>
            </div>
          );
        })}
        {(!bulkDownloadLabelList || bulkDownloadLabelList?.length === 0) && (
          <div className="w-full h-40 bg-[#f7f7f7] hover:bg-[#e9e9e9] flex rounded-lg justify-center items-center">
            No Data Found
          </div>
        )}
      </div>
    );
  };

  //on page change index
  const onPageIndexChange = async (pageIndex: any) => {
    console.log("pageindex", pageIndex);
    const { data } = await POST(GET_SYSTEM_LOG, {
      pageNo: pageIndex?.currentPage,
      limit: pageIndex?.itemsPerPage,
    });
    if (data?.success) {
      setBulkDownloadLabelList(data?.data[0]?.data);
    } else {
      toast.error(data?.message);
    }
  };

  // on per page item change
  const onPerPageItemChange = async (ItemChange: any) => {
    console.log("ItemChange", ItemChange);
    const { data } = await POST(GET_SYSTEM_LOG, {
      pageNo: ItemChange?.currentPage,
      limit: ItemChange?.itemsPerPage,
    });
    if (data?.success) {
      setBulkDownloadLabelList(data?.data[0]?.data);
    } else {
      toast.error(data?.message);
    }
  };

  return (
    <>
      {/* {isActive ? ( */}
      <div>
        <div>
          <Breadcrum label="Bulk Label List" />
        </div>
        <div className="">
          {/* Desktop (table) */}
          <div className="hidden lg:block">
            <CustomTable
              rowData={bulkDownloadLabelList}
              columnsData={bulkDownloadColumns}
            />
          </div>

          {/* Mobile/Tablet (cards) */}
          <div className="block lg:hidden">{renderCards()}</div>
        </div>
        {/* {totalItemCount > 0 && (
          <PaginationComponent
            totalItems={totalItemCount}
            itemsPerPageOptions={[
              10, 20, 50, 100, 200, 500, 1000, 2000, 5000, 10000,
            ]}
            onPageChange={onPageIndexChange}
            onItemsPerPageChange={onPerPageItemChange}
            // rightmodalPagination={true}
          />
        )} */}
      </div>
      {/* ) : (
        <div>
          <AccessDenied />
        </div>
      )} */}
    </>
  );
};

export default BulkLabelList;
